<template>
  <div class="container">
    <ProductsMenu @productsSelect="productsSelect"/>
    <div class="viewBody" >
      <div data-aos="fade-up">
        <div class="eh-ibs">
          <span class="eh-ibs-title">EH-IBS生物样本库数字化智能全息解决方案</span>
        </div>
        <div class="other-title">
          <img src="../../assets/img/products/qxzn/over.png">
        </div>
      </div>
      <div class="title" data-aos="fade-up">
        EH‑IBS 生物样本库数字化智能全息解决方案，围绕生物样本全生命周期管理，提供顶层设计、信息系统搭建、质量与能力建设等多维度能力。方案可与专病数据库平台、组学数据发布管理平台实现对接，开展数据集成、存储与分析工作，助力珍贵生物样本资源达成 “存得好，找得到，可应用” 的建设目标。
      </div>
      <div class="body-card">
        <div class="body-card-row" data-aos="zoom-in-up">
          <div v-for="(item,index) in list" :key="index" :class="index=='0'?'body-card-row-card':'body-card-row-card card-interval'">
            <div class="body-card-row-card-top flex-center">
              <div class="body-card-row-card-top-rectangle">
              </div>
            </div>
            <div class="body-card-row-card-title flex-center">{{item.title}}</div>
            <div class="body-card-row-card-body">
              <div class="body-card-row-card-body-row" v-for="(k,i) in item.children" :key="i">
                <div class="body-card-row-card-body-row-drop"></div>
                <div class="body-card-row-card-body-row-word">{{k}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="body-card-row" style="margin-top: 10px" data-aos="zoom-in-up">
          <div v-for="(item,index) in list1" :key="index" :class="index=='0'?'body-card-row-card':'body-card-row-card card-interval'">
            <div class="body-card-row-card-top flex-center">
              <div class="body-card-row-card-top-rectangle">
              </div>
            </div>
            <div class="body-card-row-card-title flex-center">{{item.title}}</div>
            <div class="body-card-row-card-body">
              <div class="body-card-row-card-body-row" v-for="(k,i) in item.children" :key="i">
                <div class="body-card-row-card-body-row-drop"></div>
                <div class="body-card-row-card-body-row-word">{{k}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-img" data-aos="slide-left">
        <div class="body-img-top">
          <div class="body-img-top-title">生物样本库数字孪生可视化大屏展示</div>
        </div>
        <div class="body-img-row">
          <img src="../../assets/img/products/qxzn/1.png" width="487" style="margin-left: 12px">
          <img src="../../assets/img/products/qxzn/2.png" width="487" style="margin-left: 12px">
        </div>
      </div>
      <div class="body-title" data-aos="fade-left">
        <div class="body-title-word">生物样本库信息管理系统</div>
      </div>
      <div class="body-dec" data-aos="fade-left">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海唐颐信息技术有限公司为全国生物样本标准化技术委员会（SAC/TC 559）归口国家标准 GB/T 39766‑2021《人类生物样本库管理规范》 的起草单位，参与该标准中生物样本库信息化相关内容的编制工作，核心团队拥有 15 年行业积淀。公司服务涵盖300余家大型三甲医院、知名高校、科研院所及企业等，在项目实践中持续迭代优化生物样本库相关产品，现已迭代 8 大版本。BioFactory 临床数据与样本资源库管理系统，实现生物样本全生命周期的规范化管理，具备采集可追溯、信息化管理、质量管控、数据分析等能力，助力保障样本信息记录的完整性、规范性与可追溯性，支撑样本质量管控业务开展，为科研工作者开展研究提供支撑，助力提升科研工作效率。
      </div>
      <div class="body-part" style="margin-top: 95px" data-aos="fade-left">
        功能描述
      </div>
      <div class="content" data-aos="fade-left">
        <div >
          <div class="redBorder"></div>
          <div class="whiteSpace"></div>
          <div class="text">样本采集与管理</div>
        </div>
        <div >
          <div class="redBorder"></div>
          <div class="whiteSpace"></div>
          <div class="text">样本处理与储存</div>
        </div>
        <div >
          <div class="redBorder"></div>
          <div class="whiteSpace"></div>
          <div class="text">外部接口管理</div>
        </div>
        <div >
          <div class="redBorder"></div>
          <div class="whiteSpace"></div>
          <div class="text">样本数据管理</div>
        </div>
        <div >
          <div class="redBorder"></div>
          <div class="whiteSpace"></div>
          <div class="text">安全控制与<br/><br/>合规管理</div>
        </div>
        <div >
          <div class="redBorder"></div>
          <div class="whiteSpace"></div>
          <div class="text">数据分析和应用</div>
        </div>
      </div>
      <div class="body-part-card">
        <div class="body-part-card-row">
          <div  v-for="(item,index) in list2" data-aos="fade-up-left" :key="index" :class="index=='0'?'body-part-card-row-card':'body-part-card-row-card part-card-interval'">
            <div class="body-part-card-row-card-top">{{item.title}}</div>
            <div class="body-part-card-row-card-list">
              <div class="body-part-card-row-card-list-row" v-for="(k,i) in item.children">
                <div class="body-part-card-row-card-list-row-round">·</div>
                <div class="body-part-card-row-card-list-row-desc">{{k}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="body-part-card-row" style="margin-top: 24px">
          <div  v-for="(item,index) in list3"  data-aos="fade-up-left"  :key="index" :class="index=='0'?'body-part-card-row-card':'body-part-card-row-card part-card-interval'">
            <div class="body-part-card-row-card-top">{{item.title}}</div>
            <div class="body-part-card-row-card-list">
              <div class="body-part-card-row-card-list-row" v-for="(k,i) in item.children">
                <div class="body-part-card-row-card-list-row-round">·</div>
                <div class="body-part-card-row-card-list-row-desc">{{k}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-part" style="margin-top: 81px" data-aos="zoom-in-up">
        系统版本
      </div>
      <div class="body-part-table" data-aos="zoom-in-up">
        <table style="width: 100%;border: 1px solid #ffffff">
          <tr>
            <td style="width: 282px;"><div class="left-title flex-center">旗舰版</div></td>
            <td style="width: 691px"><div class="right-title flex-center-right">
              多科室、管理SOP、科研协作、定制化开发<br/>
              协助客户建立起样本管理与使用SOP，支持以科研协作为目的的样本及数据共享
            </div></td>
          </tr>
          <tr>
            <td style="width: 282px;"><div class="left-title flex-center">专业版</div></td>
            <td style="width: 691px"><div class="right-title flex-center-right">
              多用户、功能全、可拓展<br/>
              完善的样本流程，针对样本进行全方位的管理
            </div></td>
          </tr>
          <tr>
            <td style="width: 282px;"><div class="left-title flex-center">标准版</div></td>
            <td style="width: 691px"><div class="right-title flex-center-right">
              单用户、灵活定制、高性价比<br/>
              可灵活设置样本编码规则，可视化容器管理，操作便捷高效
            </div></td>
          </tr>
        </table>
      </div>
      <div class="body-part" style="margin-top: 59px" data-aos="zoom-in-up">
        功能模块
      </div>
      <div  style="padding-top: 53px;margin-left: 10px" data-aos="zoom-in-up">
       <div class="body-part-table-tr">
         <div class="body-part-table-tr-left">
           主要功能
         </div>
         <div class="body-part-table-tr-right">
           <div class="body-part-table-tr-right-row" style="display:flex;">
             <div v-for="(item , index) in tableTr" :key="index" :class="index==4?'body-part-table-tr-right-td right-clear':'body-part-table-tr-right-td'">{{item}}</div>
           </div>
           <div class="body-part-table-tr-right-row" style="display:flex;margin-top: 10px;">
             <div v-for="(item , index) in tableTr1" :key="index" :class="index==4?'body-part-table-tr-right-td right-clear':'body-part-table-tr-right-td'">{{item}}</div>
           </div>
           <div class="body-part-table-tr-right-row" style="display:flex;margin-top: 10px;">
             <div v-for="(item , index) in tableTr2"  :key="index" :class="index==4?'body-part-table-tr-right-td right-clear':'body-part-table-tr-right-td'">{{item}}</div>
           </div>
           <div class="body-part-table-tr-right-row" style="display:flex;margin-top: 10px;">
             <div v-for="(item , index) in tableTr3"  :key="index" :class="index==4?'body-part-table-tr-right-td right-clear':'body-part-table-tr-right-td'">{{item}}</div>
           </div>
         </div>
       </div>
        <div class="body-part-table-tr" style="margin-top: 30px">
          <div class="body-part-table-tr-left" style="height: 117px;">基础设置</div>
          <div class="body-part-table-tr-right" style="height: auto">
            <div class="body-part-table-tr-right-row" style="display:flex;">
              <div v-for="(item , index) in tableTr4" :key="index" :class="index==4?'body-part-table-tr-right-td right-clear':'body-part-table-tr-right-td'">{{item}}</div>
            </div>
            <div class="body-part-table-tr-right-row" style="display:flex;margin-top: 10px;">
              <div v-for="(item , index) in tableTr5" :key="index" :class="index==4?'body-part-table-tr-right-td right-clear':'body-part-table-tr-right-td'">{{item}}</div>
            </div>
          </div>
        </div>
        <div class="body-part-table-tr" style="margin-top: 30px">
          <div class="body-part-table-tr-left" style="height: 51px;">系统管理</div>
          <div class="body-part-table-tr-right" style="height: auto">
            <div class="body-part-table-tr-right-row" style="display:flex;">
              <div v-for="(item , index) in tableTr6" :key="index" :class="index==4?'body-part-table-tr-right-td right-clear':'body-part-table-tr-right-td'">{{item}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-title" style="width: 290px;display: flex;align-items: center;justify-content: center" data-aos="zoom-in-up">
        <div class="body-title-word">生物样本库建设整体规划咨询</div>
      </div>
      <div class="sj-img-body">
        <img  src="../../assets/img/products/qxzn/3.png" style="margin-left: 74px" width="408" data-aos="flip-up"/>
        <img  src="../../assets/img/products/qxzn/4.png" style="margin-left: 5px" height="205" data-aos="flip-up"/>
      </div>
      <table class="gw-table"  data-aos="zoom-in-up">
        <tr>
          <td style="width: 106px;height: 46px" class="gw-table-title">序号</td>
          <td style="width: 369px;height: 46px"  class="gw-table-title">名称</td>
          <td style="width: 504px;height: 46px"  class="gw-table-title">规划内容</td>
        </tr>
        <tr >
          <td class="gw-table-td" style="text-align: center">1</td>
          <td class="gw-table-td gw-table-td-left" >实验室规划、布局、装修</td>
          <td class="gw-table-td gw-table-td-right" >吊顶装修、隔墙装修、地面装修、圆弧结构、门窗制作安装、<br/>
            不锈钢传递窗、手消毒系统</td>
        </tr>
        <tr >
          <td class="gw-table-td" style="text-align: center">2</td>
          <td class="gw-table-td gw-table-td-left" >实验室供电系统</td>
          <td class="gw-table-td gw-table-td-right" >照明电器、紫外线灭菌灯、开关插座、动力配电</td>
        </tr>
        <tr >
          <td class="gw-table-td" style="text-align: center">3</td>
          <td class="gw-table-td gw-table-td-left" >实验室自动化控制系统</td>
          <td class="gw-table-td gw-table-td-right" >风机、空调、压力、通风橱、温湿度控制系统等</td>
        </tr>
        <tr >
          <td class="gw-table-td" style="text-align: center">4</td>
          <td class="gw-table-td gw-table-td-left" >实验室弱电规划</td>
          <td class="gw-table-td gw-table-td-right" >视频监控、弱电综合网络系统</td>
        </tr>
        <tr >
          <td class="gw-table-td" style="text-align: center">5</td>
          <td class="gw-table-td gw-table-td-left" >实验室净化、空调、排风设计及施工</td>
          <td class="gw-table-td gw-table-td-right" >净化级别、送/回/排风系统、压差控制、净化空调机组、空调冷热源</td>
        </tr>
        <tr >
          <td class="gw-table-td" style="text-align: center">6</td>
          <td class="gw-table-td gw-table-td-left" >实验室配套</td>
          <td class="gw-table-td gw-table-td-right" >水盆/水槽/水龙头、洗眼器/紧急喷淋系统、滴水架、试剂架、中央<br/>
            实验台、实验边台、高温台、天平台、不锈钢操作台、药品柜/器皿<br/>
            柜/钢瓶柜/样品柜、通风橱/通风罩/原子吸收罩</td>
        </tr>
      </table>
      <div class="body-title" style="width: 172px;display: flex;align-items: center;justify-content: center;margin-top: 86px"  data-aos="zoom-in-up">
        <div class="body-title-word">设备/耗材选型咨询服务</div>
      </div>
      <div class="body-list-card" style="margin-top: 44px" data-aos="zoom-in-up">
        <div class="card-body card-first">超低温冰箱</div>
        <div class="card-body card-other">液氮罐</div>
        <div class="card-body card-other">冻存管/冻存盒/<br/>冻存架</div>
        <div class="card-body card-other">前处理及<br/>辅助设备</div>
        <div class="card-body card-other">超净工作台</div>
        <div class="card-body card-other">生物安全柜</div>
      </div>
      <div class="body-list-card" style="margin-top: 16px" data-aos="zoom-in-up">
        <div class="card-body card-first">离心机</div>
        <div class="card-body card-other">核酸提取仪</div>
        <div class="card-body card-other">干式恒温器</div>
        <div class="card-body card-other">电泳仪</div>
        <div class="card-body card-other">凝胶成像仪</div>
        <div class="card-body card-other">移液器…</div>
      </div>
      <div class="body-title" style="width: 266px;display: flex;align-items: center;justify-content: center" data-aos="fade-up">
        <div class="body-title-word">技术咨询</div>
      </div>
      <div class="low-title"  data-aos="fade-up">ISO 20387技术咨询服务</div>
      <div class="low-desc"  data-aos="fade-up">ISO 20387 规定生物样本库在能力、公正性、持续运行（含质量控制）方面的通用要求，用于保障生物样本及相关数据质量。<br/>该标准可供生物样本库、用户、监管机构、同行评估组织、认可机构用于评价与确认生物样本库运行能力。</div>
      <div class="img-desc" data-aos="slide-left">
        <div class="left">
          <div class="ti" style="margin-top: 30px"></div>
          <div class="ti" style="margin-top: 7px;background: #ed1c24"></div>
          <div class="ti" style="margin-top: 7px"></div>
          <div class="ti" style="margin-top: 7px"></div>
        </div>
        <div class="cont">
          <div class="cont-list">
            <div class="desc-card" style="margin-top: 58px">讲    解</div>
            <div class="desc-icon flex-center" >《</div>
            <div class="desc-card">执    行</div>
            <div class="desc-icon flex-center" >《</div>
            <div class="desc-card">评    价</div>
            <div class="desc-icon flex-center" >《</div>
            <div class="desc-card">完    善</div>
          </div>

        </div>
        <div  class="right">
          <div class="right-img" style="margin-top: 40px">
            <div class="round" style="margin-left: 77px">
              <img src="../../assets/img/products/qxzn/5.png" width="37px">
            </div>
            <div class="round">
              <img src="../../assets/img/products/qxzn/6.png" style="position: relative;left: 4px" width="64px">
            </div>
            <div class="round">
              <img src="../../assets/img/products/qxzn/7.png" width="37px">
            </div>
          </div>
          <div class="right-desc">
             <div class="domain" style="margin-left: 47px">
               <div class="domain-left">01</div>
               <div class="domain-cont"></div>
               <div class="domain-right">诊断与策划</div>
             </div>
            <div class="domain" style="margin-left: 70px">
              <div class="domain-left">02</div>
              <div class="domain-cont"></div>
              <div class="domain-right">结构管理</div>
            </div>
            <div class="domain" style="margin-left: 70px">
              <div class="domain-left">03</div>
              <div class="domain-cont"></div>
              <div class="domain-right">人员管理</div>
            </div>
          </div>
          <div class="right-img" style="margin-top: 79px">
            <div class="round" style="margin-left: 77px">
              <img src="../../assets/img/products/qxzn/8.png" width="37px">
            </div>
            <div class="round">
              <img src="../../assets/img/products/qxzn/9.png"  width="64px">
            </div>
            <div class="round">
              <img src="../../assets/img/products/qxzn/10.png" width="37px">
            </div>
          </div>
          <div class="right-desc">
            <div class="domain" style="margin-left: 47px">
              <div class="domain-left">06</div>
              <div class="domain-cont"></div>
              <div class="domain-right">基础实施管理</div>
            </div>
            <div class="domain" style="margin-left: 70px">
              <div class="domain-left">07</div>
              <div class="domain-cont"></div>
              <div class="domain-right">过程管理</div>
            </div>
            <div class="domain" style="margin-left: 70px">
              <div class="domain-left">08</div>
              <div class="domain-cont"></div>
              <div class="domain-right">运行与改进</div>
            </div>
          </div>
<!--          <div class="right-desc">-->
<!--            <div class="domain" style="margin-left: 47px">-->
<!--              <div class="domain-left">04</div>-->
<!--              <div class="domain-cont"></div>-->
<!--              <div class="domain-right">基础实施管理</div>-->
<!--            </div>-->
<!--            <div class="domain" style="margin-left: 52px">-->
<!--              <div class="domain-left">05</div>-->
<!--              <div class="domain-cont"></div>-->
<!--              <div class="domain-right">过程管理</div>-->
<!--            </div>-->
<!--            <div class="domain" style="margin-left: 60px">-->
<!--              <div class="domain-left">06</div>-->
<!--              <div class="domain-cont"></div>-->
<!--              <div class="domain-right">运行与改进</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
<!--      <div class="low-title"  data-aos="fade-up" style="margin-left: 34px">人类遗传资源管理行政审批服务</div>-->
<!--      <div class="low-desc"  data-aos="fade-up" style="text-indent: 34px">人类遗传资源采集、保藏、利用、对外提供过程中应当遵守《中华人民共和国人类遗传资源管理条例》（国令第717号）等的相关规<br/>定。项目须在获得中国人类遗传资源管理办公室批准或备案后方可启动开展。</div>-->
<!--      <div class="img-path" data-aos="zoom-in-up">-->
<!--        <div class="img-cr">-->
<!--          <div class="desc">-->
<!--            了解样本库实际进展，<br/>告知客户要填写的基本信息-->
<!--          </div>-->
<!--          <div class="point">-->
<!--            <div style="height: 6px"></div>-->
<!--            <point/>-->
<!--          </div>-->
<!--          <div class="desc">-->
<!--            商务沟通，<br/>签订合同&nbsp;&nbsp;&nbsp;-->
<!--          </div>-->
<!--          <div class="point">-->
<!--            <div style="height: 6px"></div>-->
<!--            <point/>-->
<!--          </div>-->
<!--          <div class="desc">-->
<!--            是否有，<br/>完善的体系文件-->
<!--          </div>-->
<!--          <div class="point">-->
<!--            <div style="height: 6px;position: relative;top: -5px;font-weight: bold">是</div>-->
<!--            <point/>-->
<!--          </div>-->
<!--          <div class="desc">-->
<!--            组织专家对体系文件，<br/>进行审核、修改-->
<!--          </div>-->
<!--          <div class="point">-->
<!--            <div style="height: 6px"></div>-->
<!--            <point/>-->
<!--          </div>-->
<!--          <div class="desc">-->
<!--            递交材料，<br/>网上申报&nbsp;&nbsp;&nbsp;-->
<!--          </div>-->
<!--          <div class="point">-->
<!--            <div style="height: 6px"></div>-->
<!--            <point/>-->
<!--          </div>-->
<!--          <div class="desc">-->
<!--            组织人遗办外聘专家库内<br/>专家进行现场复审-->
<!--          </div>-->
<!--          <div class="point" >-->
<!--            <div style="height: 6px;position: relative;top: -5px;font-weight: bold">通过</div>-->
<!--            <point/>-->
<!--          </div>-->
<!--          <div class="desc">-->
<!--            等待人遗办<br/>现场审核-->
<!--          </div>-->
<!--        </div>-->
<!--        <div style="display: flex;font-size: 12px;font-weight:bolder">-->
<!--          <div  style="display: flex;margin-left: 416px">-->
<!--            <pointDown></pointDown><span style=" line-height: 40px">否</span>-->
<!--          </div>-->
<!--          <div  style="display: flex;margin-left: 416px">-->
<!--            <pointDown></pointDown><span>不<br/>通<br/>过</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div style="display:flex;">-->
<!--          <div class="desc1" style="margin-left: 360px">组织专家填写体系文件</div>-->
<!--          <div class="desc1" style="margin-left: 320px">按预审意见进行整改</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="body-title" data-aos="fade-up" style="width: 109px;display: flex;align-items: center;justify-content: center;margin-top: 95px">
        <div class="body-title-word">综合优势</div>
      </div>
      <div data-aos="zoom-in-up">
        <img src="../../assets/img/products/qxzn/11.png" width="976px" style="margin-top: 22px"/>
      </div>
<!--      <div class="body-title" data-aos="fade-up" style="width: 109px;display: flex;align-items: center;justify-content: center;margin-top: 0px">-->
<!--        <div class="body-title-word">视频介绍</div>-->
<!--      </div>-->
<!--      <div style="width: 1000px;height:auto;margin: 10px">-->
<!--        <video style="width: 100%" controls   name="media" id="video"  poster="../../assets/mp4/1.jpg">-->
<!--          <source  src="../../assets/mp4/1.mp4" type='video/mp4' />-->
<!--        </video>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import point from "@/views/products/point";
import ProductsMenu from "@/components/ProductsMenu";
import pointDown from "@/views/products/pointDown";
export default {
  name: "qxzn",
  components:{ProductsMenu,point,pointDown},
  data(){
    return{
      list:[
          {title:'顶层设计',children:['样本库的定位和目的', '收集的样本类型', '样本信息收集内容', '样本和数据共享机制', '资金保障和持续运营']},
          {title:'信息管理系统',children: [
              '生物样本资源库管理系统',
              '菌株库管理系统',
              '数据采集系统',
              '生物资源运输监管平台',
              '多中心生物资源共享平台',
              '人类遗传资源管理系统',
              '自然人群队列研究管理平台'
            ]},
          {title:'场地布局规划咨询',children: [
              '功能区规划',
              '空间设计',
              '装饰装修',
              '通风系统',
              '消防系统',
              '供电和应急系统',
              '信息基础设施',
              '其他设备'
            ]}
      ],
      list1:[
        {title:'质量和能力建设',children:[
            "质量管理体系",
            "标准化操作流程",
            "规范化管理制度",
            "资源与服务认证",
            "流程优化",
            "质量检查与监控"
          ]},
        {title:'设备/耗材选型咨询服务',children:[
            "设备选型（存储量/预算/处理技术）",
            "设备全生命周期管理",
            "耗材选型（样本类型/处理流程）",
            "耗材采购及库存管理"
          ]},
        {title:'相关服务',children:[
            "生物资源信息共享服务",
            // "生物样本第三方储存服务",
            "样本库共建共享服务",
            "咨询与培训服务"
          ]}
      ],
      list2:[
        {title:'样本采集与管理',children:[
            "样本采集方案制定",
            "样本前处理/编码规则设置",
            "批量和扫码接收",
            "样本源信息登记/项目关联样本源",
            "捐献者信息/知情同意书文件",
            "自定义CRF表单",
            "样本出入库、自动定位入库"
          ]},
        {title:'样本数据管理',children: [
            "可视化图形展示数据概况",
            "批量Excel数据导出",
            "组合查询设置",
            "随访管理",
            "数据质控",
            "样本实验数据回溯"
          ]},
        {title: "样本处理与储存",children: [
            "图形化模拟显示容器结构",
            "自定义配置处理方案",
            "房间/存储设备管理",
            "设备温湿度监控",
            "全过程质控/质控报告",
            "自定义设置质检方案",
            "菌株样本培养传代"
          ]}
      ],
      list3:[
        {title:'安全控制与合规管理',children:[
             "样本采集方案制定",
             "样本前处理/编码规则设置",
             "批量和扫码接收",
             "样本源信息登记/项目关联样本源",
             "捐献者信息/知情同意书文件",
             "自定义CRF表单",
             "样本出入库、自动定位入库"
          ]},
        {title:'外部接口管理',children: [
             "HIS/LIS/CIS/PACS/EMR等对接",
             "临床数据平台对接集成",
             "组学数据平台对接集成",
             "实验室管理系统对接",
             "自动化样本处理和存储设备等",
             "温湿度监控管理系统",
             "数字孪生可视化大屏展示系统"
          ]},
        {title:'数据分析和应用',children: [
            "支持建立科研项目",
            "独立项目管理视图",
            "明确研究疾病/课题",
            "设计临床研究方案（CRF）",
            "样本筛选与统计服务",
            "样本及数据共享",
            "支持多组学数据回溯及展示",
            "可对接精准医学知识库平台"
          ]}
      ],
      tableTr:['容器管理',"样本列表","样本采集","样本接收","样本登记"],
      tableTr1:['样本处理','样本出入库','样本质检','质检报告','样本预警'],
      tableTr2:['样本盘库','样本还库/销毁','单据管理','样本源管理','病理管理'],
      tableTr3:['知情同意','组合查询','项目管理','人遗年报','统计图表'],
      tableTr4:['方案配置','预警规则','样本类型','病种管理','取材部位'],
      tableTr5:['编码规则','打印配置','问卷管理','扩展字段'],
      tableTr6:['机构管理','用户管理','菜单管理','角色管理','数据管理'],
      tableTr7:['超低温冰箱','液氮罐','冻存管/冻存盒\n/冻存架','前处理及\n辅助设备','超净工作台','生物安全柜']
    }
  },
  methods:{
    productsSelect(src){
      this.$emit('productsSelect',src)
    }
  }
}
</script>

<style scoped lang="less">
.container{
  width: 100%;
  margin-top:126px;
  padding-left: 20%;
  display: flex;
  position: relative;
}
.viewBody{
  flex: 1;
  margin-left: 50px;
  height: auto;
}
.eh-ibs {
  width: 100%;
  display: flex;
  height: 28px;
  &-title{
    margin-left: 208px;
    font-family: SourceHanSansCN-Normal;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 2px;
    color: #ed1c24;
  }
}
.other-title{
  width: 246px;
  margin-left: 390px;
  height: 38px;
  font-family: Dead-Island;
  font-size: 44px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #dfefff;
  white-space: nowrap;
  position: relative;
  top:-10px
}
.title{
    width: 985px;
    height: 60px;
    font-family: SourceHanSansCN-Regular;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 23px;
    letter-spacing: 1px;
    color: #000000;
    text-align: justify-all;
    margin-top: 37px;
    text-indent: 40px;
}
.body-card{
  width:100%;
  margin-top: 54px;
  height:auto;
  &-row{
    display: flex;
    &-card{
      width: 226px;
      height: 283px;
      background-image: linear-gradient(135deg,
      #ffffff 0%,
      #f1f7ff 0%,
      #e3efff 0%,
      #ffffff 100%);
      &-top{
        width: 100%;
        height: auto;
        &-rectangle{
          width: 39px;
          height: 5px;
          background-color: #c8e0ff;
        }
      }
      &-title{
        width: 100%;
        margin-top: 15px;
        margin-bottom: 25px;
        height: 19px;
        font-family: SourceHanSansCN-Medium;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #000000;
    }
      &-body{
        width: 100%;
        &-row{
          width: 300px;
          height: 26px;
          display: flex;
          align-items: center;
          &-drop{
            width: 7px;
            height: 7px;
            background: #0b96fa;
            transform:rotate(45deg);
            margin-left: 21px;
            margin-right: 11px;
          }
          &-word{
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #000000;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
.body-img{
  width: 100%;
  margin-top: 16px;
  height: auto;
  background-color: #006efd;
  padding-top: 58px;
  padding-bottom: 85px;
  &-top{
   width: 100%;
   height: 29px;
    &-title{
      margin-left: 233px;
      font-family: SourceHanSansCN-Medium;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 23px;
      letter-spacing: 2px;
      color: #ffffff;
    }

  }
  &-row{
    width: 100%;
    margin-top: 51px;
    display: flex;
  }
}
.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-interval{
  margin-left: 142px;
}
.body-title{
  width: 245px;
  background-color: #006efd;
  padding:5px;
  margin-top: 97px;
  &-word{
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    //line-height: 23px;
    letter-spacing: 2px;
    color: #ffffff;
  }
}
.body-dec{
  margin-top: 39px;
  width: 986px;
  font-family: SourceHanSansCN-Normal;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
  color: #333333;
}
.body-part{
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 23px;
  letter-spacing: 2px;
  color: #333333;
}
.content{
  width: 100%;
  //margin: 0 auto;
  padding-top: 37px;
  padding-left: 16px;
  display: flex;
  //box-sizing: border-box;
  //display: flex;
  //justify-content: space-between;
  &>div{
    width: 167px;
    height: 212px;
    position: relative;
    .redBorder{
      position: absolute;
      z-index: 1;
      width: 134px;
      height: 136px;
      box-sizing: border-box;
      border: 9px solid #006efd;
      border-radius: 50%;
    }
    .whiteSpace{
      position: absolute;
      z-index: 2;
      width: 134px;
      height: 109px;
      background: #fff;
    }
    .text{
      position: absolute;
      z-index: 3;
      width: 134px;
      height: 126px;
      border:1px solid #e1e1e1;
      border-radius: 50%;
      border-bottom-color: #006efd;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-family: SourceHanSansCN-Normal;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      //line-height: 53px;
      letter-spacing: 2px;
      color: #333333;
    }
  }
}
.part-card-interval{
  margin-left: 64px;
}
.body-part-card{
  width: 100%;
  height: auto;
  padding-left: 15px;
  &-row{
    width: 100%;
    display: flex;
    &-card{
      width: 282px;
      height: 279px;
      background-color: #eeeeee;
      padding-top: 20px;
      &-top{
        margin-left: 24px;
        font-family: SourceHanSansCN-Medium;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 1px;
        color: #333333;
      }
      &-list{
        margin-top: 18px;
        margin-left: 15px;
        &-row{
          display: flex;
          align-items: center;
          height: 26px;
          &-round{
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #333333;
          }
          &-desc{
            margin-left: 4px;
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #333333;
          }
        }
      }
    }
  }
}
.body-part-table{
  width: 976px;
  margin-top: 52px;
  padding: 0px 10px;
  td{
    height: 123px;
  }
  .left-title{
    width: 100%;
    height: 100%;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 2px;
    color: #006efd;
    background-color: #f3f3f3;
  }
  .right-title{
    width: 691px;
    height: 100%;
    background-color: #e6f1ff;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
  }
}
.flex-center-right{
  display: flex;
  align-items: center;
  padding-left: 41px;
}
.body-part-table-tr{
  width: 100%;
  display: flex;
  &-left{
    width: 131px;
    height: 238px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f3f3f3;
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 2px;
    color: #006efd;
  }
  &-right{
    height: 238px;
    position: relative;
    margin-left: 20px;
    &-td{
      width: 150px;
      height: 52px;
      background-color: #e6f1ff;
      font-family: SourceHanSansCN-Normal;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      letter-spacing: 1px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 18px;
    }
  }
}
.right-clear{
  margin-right: 0px;
}
.sj-img-body{
  width: 100%;
  margin-top: 76px;
}
.gw-table{
  border: 3px solid #ffffff;
  margin-top: 66px ;
  &-title{
    background-color: #e6f1ff;
    font-family: SourceHanSansCN-Normal;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 2px;
    color: #333333;
    text-align: center;
  }
  &-td{
    height: 75px;
    background-color: #f3f3f3;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 1px;
    color: #333333;
    &-left{
      padding-left: 36px;
    }
    &-right{
      padding-left: 12px;
    }
  }
}
.body-list-card{
  width: 100%;
  display: flex;
  .card-body{
    width: 128px;
    height: 52px;
    background-color: #e6f1ff;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .card-first{
    margin-left: 42px;
  }
  .card-other{
    margin-left: 19px;
  }
}
.low-title{
  margin-top: 42px;
  margin-left: 18px;
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 23px;
  letter-spacing: 2px;
  color: #333333;
}
.low-desc{
  margin-top: 17px;
  text-indent: 18px;
  font-family: SourceHanSansCN-Normal;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
  color: #333333;
}
.img-desc{
  width: 100%;
  height: 488px;
  margin-top: 47px;
  display: flex;
  .left{
    width: 3px;
    height: 100%;
    .ti{
      height: 95px;
      background: #006efd;
    }
  }
  .cont{
    width: 329px;
    height: 100%;
    .cont-list{
      width: 192px;
      margin-left: 90px;
      .desc-card{
        width: 100%;
        height: 50px;
        background-color: #ffffff;
        border: solid 1px #006efd;
        font-family: SourceHanSansCN-Normal;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #006efd;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .desc-icon{
        width: 100%;
        height: 53px;
        transform: rotate(-90deg);
        font-family: SourceHanSansCN-Normal;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #006efd;
      }
    }
  }
  .right{
    width: 646px;
    height: 100%;
    background-image: linear-gradient(-90deg,
    #f1f7ff 0%,
    #ffffff 100%);
    .right-img{
      width: 100%;
      display: flex;
      .round{
        width: 102px;
        height: 102px;
        margin-left: 113px;
        background-color: #e9f2ff;
        border: solid 1px #006efd;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .right-desc{
      width: 100%;
      display: flex;
      .domain{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        &-left{
          font-family: E-F7;
          font-size: 27px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 23px;
          letter-spacing: 2px;
          color: #006efd;
        }
        &-cont{
          width: 1px;
          height: 33px;
          background-color: #006efd;
          margin-left: 13px;
          margin-right: 12px;
        }
        &-right{
          width: 80px;
          font-family: SourceHanSansCN-Medium;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          //line-height: 23px;
          letter-spacing: 1px;
          color: #006efd;
          white-space: nowrap;
        }
      }
    }
  }
}
.img-path{
  width: 986px;
  height: 201px;
  margin-top: 47px;
  background-image: linear-gradient(-90deg,
  #f1f8ff 0%,
  #d1e8ff 100%);
  .row{
    display: flex;
    padding-left: 86px;
    padding-top: 36px;
    .div{
      padding: 12px 6px;
      background: #354CFB;
      color: white;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      white-space: nowrap;
      border-radius: 10px;
    }
  }
  .desc1{
    height: 12px;
    padding: 12px 6px;
    background: #354CFB;
    color: white;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    white-space: nowrap;
    border-radius: 10px;
  }
  .img-cr{
    width: 842px;
    //height: 136px;
    margin-left: 20px;
    padding-top: 36px;
    display: flex;
    .desc{
      //height: auto;
      height: 30px;
      padding: 12px 6px;
      background: #354CFB;
      color: white;
      text-align: center;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      //line-height: 16px;
      white-space: nowrap;
      border-radius: 10px;
    }
    .point{
      //width: 30px;
      position: relative;
      //height: 400px;
      margin-top: 8px;
      font-size: 12px;
      text-align: center;
      margin-left: 3px;
      margin-right: 3px;
      .point-img{
        position: absolute;
      }
    }
    //.point{
    //  width: 30px;
    //  margin-left: 5px;
    //  display: flex;
    //  justify-content: center;
    //  align-items: center;
    //  .body{
    //    width: 12px;
    //    height: 10px;
    //    background: #354CFB;
    //  }
    //  .top{
    //    border: 8px solid transparent;
    //    border-left: 8px solid #354CFB;
    //    width: 0;
    //    height: 0px;
    //
    //  }
    //}
  }
}
</style>